import Home from '../page/Home';
import NotFound from '../page/403';
import FaceContrast from '../page/FaceContrast';
import ClassificationOfIrises from '../page/Iris';
import DeepReinforcementLearning from '../page/DeepReinforcementLearning';
import CropDiseasesAndPests from '../page/CropDiseasesAndPests';
import PatternRecognitionExpertSystem from '../page/patternRecognitionExpertSystem';
import SpeakerRecognition from '../page/speakerRecognition';
import TextCreateImage from '../page/textCreateImage';
import Bluetooth from '../page/Bluetooth';
import Speechcx2 from '../page/speechcx2';
import Weather from '../page/weather';
import LicensePlate from '../page/LicensePlate';
import QRCode from '../page/qrcode';
import Fruits from '../page/fruits';
import CxSpeech2Text from '../page/cxspeech2Text';
export const routes = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/faceContrast',
    element: <FaceContrast />,
    extention: true
  },
  {
    path: '/iris',
    element: <ClassificationOfIrises />,
    extention: true
  },
  {
    path: '/deepReinforcementLearning',
    element: <DeepReinforcementLearning />,
    extention: true
  },
  {
    path: '/crops',
    element: <CropDiseasesAndPests />,
    extention: true
  },
  {
    path: '/patternRecognition',
    element: <PatternRecognitionExpertSystem />,
    extention: true
  },
  {
    path: '/speakerRecognition',
    element: <SpeakerRecognition />,
    extention: true
  },
  {
    path: '/textCreateImage',
    element: <TextCreateImage />,
    extention: true
  },
  {
    path: '/speechcx2',
    element: <Speechcx2 />,
    extention: true
  },
  {
    path: '/weather',
    element: <Weather />,
    extention: true
  },
  {
    path: '/licensePlate',
    element: <LicensePlate />,
    extention: true
  },
  {
    path: '/bluetooth',
    element: <Bluetooth />
  },
  {
    path: '/403',
    element: <NotFound />
  },
  {
    path: '/qrcode',
    element: <QRCode />,
    extention: true
  },
  {
    path: '/fruits',
    element: <Fruits />,
    extention: true
  },
  {
    path: '/cxspeech2Text',
    element: <CxSpeech2Text />,
    extention: true
  }
];

export const Route404 = {
  path: '/*',
  redirect: '/'
};
